import { useEffect, useRef, useState } from 'react';

const projects = [
  {
    id: 1,
    title: 'Cedar Deck Build – Burlington',
    category: 'Decks &amp; Fences',
    imageUrl:
      'https://public.readdy.ai/ai/img_res/9b19a098cfdb95a88a324e8fe1d59331.jpg',
  },
  {
    id: 2,
    title: 'Full Kitchen Renovation – Oakville',
    category: 'Home Renovations',
    imageUrl:
      'https://readdy.ai/api/search-image?query=Completed%20modern%20kitchen%20renovation%20bright%20white%20cabinets%20quartz%20countertops%20stainless%20steel%20appliances%20backsplash%20tile%2C%20professional%20interior%20photography%2C%20residential%20home%20improvement%20result%2C%20clean%20contemporary%20style%2C%20natural%20lighting&width=600&height=450&seq=proj2&orientation=landscape',
  },
  {
    id: 3,
    title: 'Privacy Fence Installation',
    category: 'Decks &amp; Fences',
    imageUrl:
      'https://readdy.ai/api/search-image?query=New%20white%20vinyl%20privacy%20fence%20installation%20in%20suburban%20residential%20backyard%2C%20clean%20fresh%20fence%20panels%20with%20green%20lawn%2C%20professional%20fence%20construction%20result%2C%20bright%20daylight%20photography%2C%20neat%20property%20boundary%20Burlington%20Ontario&width=600&height=450&seq=proj3&orientation=landscape',
  },
  {
    id: 4,
    title: 'Lawn Maintenance Package',
    category: 'Property Maintenance',
    imageUrl:
      'https://readdy.ai/api/search-image?query=Perfectly%20maintained%20residential%20lawn%20and%20garden%20with%20freshly%20mowed%20green%20grass%20edged%20pathways%20trimmed%20hedges%20colorful%20flower%20beds%2C%20professional%20property%20maintenance%20result%2C%20Burlington%20Ontario%20suburban%20home%20exterior%2C%20bright%20summer%20daylight%20photography&width=600&height=450&seq=proj4&orientation=landscape',
  },
  {
    id: 5,
    title: 'Bathroom Remodel – Hamilton',
    category: 'Home Renovations',
    imageUrl:
      'https://readdy.ai/api/search-image?query=Modern%20bathroom%20renovation%20with%20large%20format%20tile%20walk-in%20shower%20floating%20vanity%20brushed%20nickel%20fixtures%2C%20professional%20interior%20photography%2C%20residential%20renovation%20completed%20project%20result%2C%20clean%20contemporary%20design%2C%20natural%20lighting&width=600&height=450&seq=proj5&orientation=landscape',
  },
  {
    id: 6,
    title: 'Multi-Level Deck – Oakville',
    category: 'Decks &amp; Fences',
    imageUrl:
      'https://readdy.ai/api/search-image?query=Large%20multi-level%20composite%20wood%20deck%20with%20pergola%20railings%20and%20outdoor%20furniture%2C%20residential%20backyard%20construction%20project%20completed%2C%20professional%20building%20photography%2C%20warm%20sunset%20light%20on%20deck%20surface%2C%20Oakville%20Ontario%20Canada&width=600&height=450&seq=proj6&orientation=landscape',
  },
];

export default function Projects() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="projects" className="bg-white py-20 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-[#C8A97E] text-xs font-bold tracking-[0.4em] uppercase mb-4">
            OUR WORK
          </p>
          <h2
            className="text-[#2B5741] text-4xl font-bold mb-3"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            Recent Projects
          </h2>
          <p className="text-gray-500 text-sm max-w-xl mx-auto" style={{ fontFamily: 'Inter, sans-serif' }}>
            Take a look at some of the work we've completed for homeowners across Burlington, Oakville, and Hamilton.
          </p>
        </div>

        <div
          ref={ref}
          className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 transition-all duration-700 ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          {projects.map((project) => (
            <div
              key={project.id}
              className="group overflow-hidden rounded-lg cursor-pointer"
            >
              <div className="w-full h-56 overflow-hidden">
                <img
                  src={project.imageUrl}
                  alt={project.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  width="600"
                  height="450"
                  loading="lazy"
                  decoding="async"
                />
              </div>
              <div className="p-4 bg-[#F7F5F1]">
                <p
                  className="text-[10px] text-[#C8A97E] font-bold uppercase tracking-widest mb-1"
                  dangerouslySetInnerHTML={{ __html: project.category }}
                />
                <p className="text-gray-800 font-semibold text-sm">{project.title}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href="#contact"
            className="inline-block bg-[#2B5741] text-white px-8 py-3 text-xs font-bold uppercase tracking-[0.2em] hover:bg-[#3A7060] transition-colors whitespace-nowrap rounded-md"
          >
            START YOUR PROJECT
          </a>
        </div>
      </div>
    </section>
  );
}
